module.exports = __webpack_public_path__ + "img/character.e5c589f.jpg";